import { useSelector } from 'react-redux';
import { usePageViewEvent, useUpdateWindowType } from 'common/hooks';
import { selectPageModelCategoryId } from '../../store/pageModel';
import { selectSelectedStoreCode } from '../../containers/instore';

export const useInstorePage = () => {
	useUpdateWindowType();
	usePageViewEvent();

	const categoryId = useSelector(selectPageModelCategoryId);
	const selectedStoreCode = useSelector(selectSelectedStoreCode);

	return {
		categoryId,
		isStoreSelected: !!selectedStoreCode,
	};
};
